// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconXbtc } from "../../../icons/full/build/icon-xbtc.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const XbtcIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconXbtc.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  XbtcIcon.displayName = 'XbtcIcon';
}

export default XbtcIcon;